<template>
<div class="chapter">
<div class="inner_page">
<p class="C767"><strong><a id="page_17">I</a></strong></p><a id="page_17">
<p class="C771"><strong>Income Inequality</strong></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_I__INCOME_INEQUALITY.vue?2b441c86